import { z } from "zod";

export const medicationSchema = z.object({
  sig: z.string().optional(),
  dispenseQuantity: z.coerce.number().positive().optional(),
  dispenseUnit: z.string().optional(),
  daysSupply: z.coerce.number().max(365).positive().optional(),
  refills: z.coerce.number().max(12).optional(),
  notes: z.string().optional(),
  substitutionsAllowed: z.boolean().optional(),
  pharmacyId: z.string().optional(),
  pharmacySystem: z.string().optional(),
  overrideReason: z.string().optional(),
});

export const otcPrescriptionSchema = z.object({
  details: z.string(),
});
